export default __webpack_public_path__ + "assets/aac/ef714f57514154b1ff0d6e946561fadd.aac";